// removed by extract-text-webpack-plugin
module.exports = {"formInput":"styles__formInput___2WuAw","formTextArea":"styles__formTextArea___3B_rj"};


//////////////////
// WEBPACK FOOTER
// ./src/views/collaborate/collaborator-panel/invite-form/styles.css
// module id = 1086
// module chunks = 0